export enum CopilotDabTelemetryEvent {
    CopilotDab_Rendered = 'CopilotDab_Rendered',
    CopilotDab_PopoverOpened = 'CopilotDab_PopoverOpened',
    CopilotDab_SuggestionClicked = 'CopilotDab_SuggestionClicked',
    CopilotDab_ButtonClicked = 'CopilotDab_ButtonClicked',
}

export const CopilotDabScenario = 'NonFloatingCopilot';

/**
 * These are the official Copilot DAB entrypoints used by the IDEAs dashboards.
 * Additional module-specific entrypoints may be added over time (e.g., Mail / Calendar).
 * But these ones specifically are the ones to represent the canonical set for all-up reporting.
 */
export enum CopilotDabEntrypoint {
    ReadingPane = 'reading_pane',
    MessageList = 'message_list',
    Compose = 'full_compose',
    ForwardCompose = 'forward_compose',
    ReplyReplyAllCompose = 'reply_replyall_compose',
    PopoutReadingPane = 'popout_reading_pane',
    PopoutCompose = 'popout_compose',
    Calendar = 'calendar',

    /**
     * Fallback entrypoint, in case someone adds a new Copilot Dab scenario without updating the
     * entrypoint mapping logic.
     */
    Unknown = 'unknown',
}
